/**
 * Location input component with work radius slider and willing to travel option
 */
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Globe, Plane, Check } from "lucide-react";

export function LocationInput({ 
  city, setCity,
  state, setState,
  zipCode, setZipCode,
  workRadius, setWorkRadius,
  willingToTravel, setWillingToTravel
}) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">
        <Globe className="w-5 h-5 inline mr-2" />
        Location & Work Area
      </h2>
      
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <Label className="text-sm text-white/60 uppercase tracking-wider">City</Label>
            <Input
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Los Angeles"
              className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
              data-testid="city-input"
            />
          </div>
          <div>
            <Label className="text-sm text-white/60 uppercase tracking-wider">State</Label>
            <Input
              value={state}
              onChange={(e) => setState(e.target.value)}
              placeholder="CA"
              className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
              data-testid="state-input"
            />
          </div>
          <div>
            <Label className="text-sm text-white/60 uppercase tracking-wider">ZIP Code</Label>
            <Input
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              placeholder="90001"
              className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
              data-testid="zipcode-input"
            />
          </div>
        </div>
        
        <div>
          <div className="flex justify-between mb-2">
            <Label className="text-sm text-white/60 uppercase tracking-wider">Work Radius</Label>
            <span className="text-white font-bold">{workRadius} miles</span>
          </div>
          <Slider
            value={[workRadius]}
            onValueChange={(value) => setWorkRadius(value[0])}
            max={200}
            min={5}
            step={5}
            className="py-4"
            data-testid="work-radius-slider"
          />
          <p className="text-white/40 text-sm">How far you're willing to travel for jobs</p>
        </div>

        {/* Willing to Travel Option */}
        {setWillingToTravel && (
          <div 
            className="flex items-start gap-3 p-4 bg-white/[0.02] rounded-sm border border-white/5 cursor-pointer hover:bg-white/[0.04] transition-colors"
            onClick={() => setWillingToTravel(!willingToTravel)}
            data-testid="willing-to-travel-toggle"
          >
            <div className={`w-5 h-5 rounded border flex items-center justify-center shrink-0 mt-0.5 transition-colors ${
              willingToTravel ? "bg-coral border-coral" : "border-white/20"
            }`}>
              {willingToTravel && <Check className="w-3.5 h-3.5 text-white" />}
            </div>
            <div>
              <div className="flex items-center gap-2">
                <Plane className="w-4 h-4 text-coral" />
                <span className="font-semibold">Willing to Travel</span>
              </div>
              <p className="text-white/50 text-sm mt-1">
                Show me in job matches beyond my work radius. I'm open to traveling for the right opportunities.
              </p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}

export default LocationInput;
